import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorService } from '../../../core/services/error.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { errorDefaultConfig } from './error.config';
import { MatButtonModule } from '@angular/material/button';

export type ErrorConfig = {
  status: number;
  title: string;
  message?: string;
};

@Component({
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './error-layout.component.html',
  styleUrls: ['./error-layout.component.sass'],
})
export class ErrorLayoutComponent implements OnInit, OnDestroy {
  errorConfig: ErrorConfig | null = null;
  private destroy$ = new Subject<void>();
  private defaultErrorConfigs: Record<number, ErrorConfig> = errorDefaultConfig;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.route.data.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data[`errorConfig`]) {
        this.errorConfig = data[`errorConfig`];
      }
      const serviceError = this.errorService.getError();
      if (serviceError) {
        const status = serviceError.status;
        this.errorConfig = serviceError || this.defaultErrorConfigs[status];
        return;
      }
      const routeStatus = data[`status`] || 404;
      this.errorConfig = this.defaultErrorConfigs[routeStatus];
    });
    this.errorService.error$
      .pipe(takeUntil(this.destroy$))
      .subscribe((error) => {
        if (error) {
          const status = error.status || 500;
          this.errorConfig = error || this.defaultErrorConfigs[status];
        }
      });
  }

  goHome(): void {
    this.errorService.clearError();
    this.router.navigate(['/']).finally(() => {});
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
